import styled, { css } from 'styled-components';

import Table from 'components/Table';

import { TableStyleProps } from './types';

const hoverStylePseudoClasses = css`
  content: '';
  z-index: 0;
  position: absolute;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  height: 100%;
  top: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.white};
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  padding-top: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const StyledTable = styled(Table)<TableStyleProps>`
  thead tr {
    padding: ${({ theme }) => theme.yoga.spacing.zero};
    height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
    text-indent: ${({ theme }) => theme.yoga.spacing.zero};

    th {
      max-width: none;
      letter-spacing: 1px;
      text-transform: none;
      padding-top: ${({ theme }) => theme.yoga.spacing.zero};
      padding-left: ${({ theme }) => theme.yoga.spacing.zero};
      padding-bottom: ${({ theme }) => theme.yoga.spacing.zero};
      padding-right: ${({ theme }) => theme.yoga.spacing.small}px;
      font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
      width: ${({ columnsQuantity, nameColumnWidth }) =>
        `calc((100% - ${nameColumnWidth}) / ${columnsQuantity})`};
    }

    th:first-of-type {
      width: ${({ nameColumnWidth }) => nameColumnWidth};
    }

    th:last-of-type {
      width: ${({ hasActionColumn }) => hasActionColumn && '32px'};
    }
  }

  tbody {
    tr {
      background-color: transparent !important;
      text-indent: ${({ theme }) => theme.yoga.spacing.zero};
      position: relative;

      td {
        padding-right: ${({ theme }) => theme.yoga.spacing.small}px;
        line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
        border-bottom: ${({ theme }) =>
          `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
      }

      td:first-letter {
        text-transform: capitalize;
      }

      &:hover {
        background-color: ${({ theme }) =>
          theme.yoga.colors.backgroundLight} !important;

        td {
          &::before {
            ${hoverStylePseudoClasses}
            width: 100%;
            top: 0;
            left: -100%;
          }

          &::after {
            ${hoverStylePseudoClasses}
            width: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
            margin-right: -${({ theme }) => theme.yoga.spacing.xxlarge}px;
            right: 0;
          }
        }
      }
    }
    tr:first-of-type {
      border-top: 0 !important;
    }
  }
`;

export const FullnameText = styled.p`
  cursor: pointer;
  width: fit-content;
`;
